__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/abfc1383a087b200ee0793ef6c21b03785dd7a00/_next/";